export default __webpack_public_path__ + "static/media/forest.c92b5872.mp3";